// extracted by mini-css-extract-plugin
export default {"h1":"NX2FLK","h2":"oDKCjt","h3":"O8EY1y","h5":"PBQhlL"};